<script>
  import { checkbox } from 'vue-strap';
  import projetoServico from '~modulos/projeto/servico';
  
  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true,
      },
      tipos: {
        type: Object,
        required: true, 
      },
      motivos: {
        type: Object,
        required: true, 
      },
      rubricas: {
        type: Array,
        required: true,
      },
      rubricaSubrubrica: {
        type: Object,
        required: true,
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        fundacoesLiberadas: ['FAFQ'],
        subrubricas: [],
        valoresDiaria: [],
        quantidadeAnterior: '',
      }
    },
    computed: {
      valorTotalDiaria() {
        if (this.solicitacao.quantidadeDiaria && this.solicitacao.quantidadeDiaria.length > 0) {
          this.solicitacao.quantidadeDiaria = this.solicitacao.quantidadeDiaria.replace('.', '');

          if (/^\d{0,2}[0-9](\,\d{0,1}[0-9])?$/.test(this.solicitacao.quantidadeDiaria)) {
            this.quantidadeAnterior = this.solicitacao.quantidadeDiaria;
          } else {
            if (this.solicitacao.quantidadeDiaria.includes(',')) {
              const quantidadeSplitada = this.solicitacao.quantidadeDiaria.split(',');

              if (quantidadeSplitada.length === 2) {
                if (quantidadeSplitada[0].length > 3 || quantidadeSplitada[1].length > 2) {
                  this.solicitacao.quantidadeDiaria = this.quantidadeAnterior;
                }
              }
            } else {
              this.solicitacao.quantidadeDiaria = this.quantidadeAnterior;
            }
          }
        }

        const quantidade = this.$options.filters.formatarNumero(this.solicitacao.quantidadeDiaria || 0, true);
        const quantidadeInteiro = parseInt(quantidade);
        const quantidadeDecimal = parseFloat(quantidade - quantidadeInteiro);
        let valorUnitario = this.$options.filters.formatarNumero(this.solicitacao.valorUnitarioDiaria || 0, true);
        const valorTotalKmRodado = this.$options.filters.formatarNumero(this.solicitacao.valorTotalKmRodado || 0, true);
        const taxaEmbarque = this.$options.filters.formatarNumero(this.solicitacao.taxaEmbarque || 0, true);
        const descontoAlimentacao = this.$options.filters.formatarNumero(this.solicitacao.descontoAlimentacao || 0, true);

        if (valorUnitario > 0 && this.solicitacao.incluiHospedagem && this.configuracao.pagarDiariaMetadeComHospedagem) {
          valorUnitario /= 2;
        }

        const totalComMeiaDiaria = (quantidadeDecimal > 0 ? (quantidadeDecimal * valorUnitario) : 0);

        const totalSemMeiaDiaria = (quantidadeInteiro * valorUnitario) + taxaEmbarque + valorTotalKmRodado - descontoAlimentacao;

        return (totalSemMeiaDiaria + totalComMeiaDiaria).toFixed(2);
      },
      motivoContador() {
        let quantidadeCaracteres = this.motivos.diaria ?
          this.motivos.diaria.length : 0;

        return 500 - quantidadeCaracteres;
      },
      controlarTamanhoTela() {
        const tamanhoBase = 1805;
        return window.innerWidth <= tamanhoBase;
      },
      controlarTamanhoTelaKM() {
        const tamanhoBaseMaior = 1805;
        const tamanhoBaseMenor = 1604;
        return window.innerWidth >= tamanhoBaseMenor && window.innerWidth <= tamanhoBaseMaior;
      },
      exibirRubricaSubrubricaSolicitacaoWeb() {
        return this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || this.solicitacao.projeto.utilizarRubricaSubrubricaWeb;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      limparSubrubricas() {
        this.subrubricas = [];
      },
      listaDeSubrubricas(idProjeto = null, idRubrica = null) {
        idProjeto = this.solicitacao.idProjeto || idProjeto;
        idRubrica = this.rubricaSubrubrica.idRubrica || idRubrica;

        this.rubricaSubrubrica.idSubrubrica = '';
        this.subrubricas = [];

        if (!idRubrica) return;

        return projetoServico
          .subrubricas(idProjeto, idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      projetoAlterado() {
        projetoServico
          .valoresDiaria(this.solicitacao.idProjeto)
          .then(valoresDiaria => {
            this.valoresDiaria = valoresDiaria;

            if (!this.$route.params.id) {
              this.solicitacao.valorUnitarioDiaria = '';
            }
          });
      },
      selecionarValorDiaria() {
        let diaria = this.valoresDiaria.find(diaria => {
          if (diaria.idProjetoValorDiaria == this.solicitacao.idProjetoValorDiaria) {
            return diaria;
          }
        });
        
        if (diaria) {
          this.solicitacao.valorUnitarioDiaria = diaria.valorDiaria;
        } else {
          this.solicitacao.valorUnitarioDiaria = '';
        }
      },
      blurQuantidadeDiaria() {
        if (this.solicitacao.quantidadeDiaria && this.solicitacao.quantidadeDiaria.includes(',')) {
          const quantidadeSplitada = this.solicitacao.quantidadeDiaria.split(',');

          if (quantidadeSplitada.length === 2) {
            if (quantidadeSplitada[1].length === 0) {
              this.solicitacao.quantidadeDiaria = this.solicitacao.quantidadeDiaria.replace(',', '');
            }
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        $('.chackboxes .checkbox')
          .css('display', 'inline')
          .css('margin-right', '10px');
      });
    },
    watch: {
      'rubricaSubrubrica.idRubrica': 'limparSubrubricas',
      'solicitacao.idProjeto': 'projetoAlterado',
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group chackboxes">
          <checkbox v-if="!edicao"
                    v-model="tipos.diaria"
                    :true-value="true"
                    type="success">
            Diárias
          </checkbox>

          <checkbox v-model="solicitacao.diariaCeletista"
                    :true-value="true"
                    type="success">
            Diária para contrato CLT
          </checkbox>

          <checkbox v-model="solicitacao.incluiHospedagem"
                    :true-value="true"
                    type="success">
            Marque o botão ao lado se a {{ configuracao.abreviaturaFundacao }} fornecerá hospedagem
          </checkbox>
        </div>
      </div>
    </div>

    <div class="row" v-if="exibirRubricaSubrubricaSolicitacaoWeb">
      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
          <label class="control-label" for="rubrica">Rubrica</label>

          <select class="form-control"
                  id="rubrica"
                  v-model="rubricaSubrubrica.idRubrica"
                  data-vv-name="rubrica"
                  data-vv-as="rubrica"
                  :disabled="!tipos.diaria"
                  v-validate="'required'"
                  @change="listaDeSubrubricas">
            <option value="">Selecione...</option>
            <option :value="rubrica.id"
                    v-for="rubrica in rubricas">
              {{ rubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
          <label class="control-label" for="subrubrica">Subrubrica</label>

          <select class="form-control"
                  id="subrubrica"
                  v-model="rubricaSubrubrica.idSubrubrica"
                  data-vv-name="subrubrica"
                  data-vv-as="subrubrica"
                  :disabled="!tipos.diaria"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="subrubrica.id"
                    v-for="subrubrica in subrubricas">
              {{ subrubrica.nome }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="valoresDiaria.length > 0">
      <div class="col-md-12">
        <div class="form-group required" :class="{'has-error': errors.has('valoresDiaria')}">
          <label class="control-label" for="valores-diaria">Valores definidos de diária</label>

          <select class="form-control"
                  id="valores-diaria"
                  v-model="solicitacao.idProjetoValorDiaria"
                  @change="selecionarValorDiaria"
                  data-vv-name="valoresDiaria"
                  data-vv-as="valores definidos de diária"
                  :disabled="!tipos.diaria"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="x.idProjetoValorDiaria"
                    v-for="x in valoresDiaria">
              {{ x.deslocamentoDiaria }} - {{ x.cargoFuncaoDiaria }} - Valor: R$ {{ x.valorDiaria | formatarNumero }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('valoresDiaria')">{{ errors.first('valoresDiaria') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-2">
        <div class="form-group required" :class="{'has-error': errors.has('quantidadeDiaria')}">
          <br v-if="controlarTamanhoTela" />
          <label class="control-label" for="quantidade-diaria">Quantidade</label>

          <input id="quantidade-diaria"
                 class="form-control align-self-end"
                 type="text"
                 v-model="solicitacao.quantidadeDiaria"
                 :disabled="!tipos.diaria"
                 @blur="blurQuantidadeDiaria()"
                 data-vv-name="quantidadeDiaria"
                 data-vv-as="quantidade"
                 v-validate="tipos.diaria ? 'required' : ''">

          <p class="text-danger" v-show="errors.has('quantidadeDiaria')">{{ errors.first('quantidadeDiaria') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group required" :class="{'has-error': errors.has('valorUnitarioDiaria')}">
          <br v-if="controlarTamanhoTela" />
          <label class="control-label" for="valor-unitario-diaria">Valor unitário</label>

          <input id="valor-unitario-diaria"
                 class="form-control text-right"
                 type="text"
                 v-model="solicitacao.valorUnitarioDiaria"
                 :disabled="!tipos.diaria"
                 :readonly="valoresDiaria.length > 0"
                 v-mascara="'moeda'"
                 data-vv-name="valorUnitarioDiaria"
                 data-vv-as="valor unitário"
                 v-validate="tipos.diaria ? 'required' : ''">

          <p class="text-danger" v-show="errors.has('valorUnitarioDiaria')">{{ errors.first('valorUnitarioDiaria') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group">
          <label class="control-label" for="taxa-embarque-diaria">Taxa de embarque / deslocamento</label>

          <input id="taxa-embarque-diaria"
                 class="form-control text-right"
                 type="text"
                 v-model="solicitacao.taxaEmbarque"
                 :disabled="!tipos.diaria"
                 v-mascara="'moeda'">
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group">
          <br v-if="controlarTamanhoTela" />
          <label class="control-label" for="desconto-alimentacao-diaria">Desconto alimentação</label>

          <input id="desconto-alimentacao-diaria"
                 class="form-control text-right"
                 type="text"
                 v-model="solicitacao.descontoAlimentacao"
                 :disabled="!tipos.diaria"
                 v-mascara="'moeda'">
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group">
          <br v-if="controlarTamanhoTelaKM" />
          <label class="control-label" for="valor-total-km-rodado">    Valor total de KM rodado (R$)</label>

          <input id="valor-total-km-rodado"
                 class="form-control text-right"
                 type="text"
                 v-model="solicitacao.valorTotalKmRodado"
                 :disabled="!tipos.diaria"
                 v-mascara="'moeda'">
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group">
          <br v-if="controlarTamanhoTela" />
          <label class="control-label">Valor total</label>

          <input class="form-control text-right"
                 type="text"
                 :value="valorTotalDiaria | formatarNumero"
                 disabled>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('motivoDiaria')}">
          <label class="control-label" for="motivo-diaria">Motivo / Justificativa ({{ motivoContador }})</label>

          <textarea class="form-control"
                    id="motivo-diaria"
                    v-model="motivos.diaria"
                    :disabled="!tipos.diaria"
                    maxlength="500"
                    data-vv-name="motivoDiaria"
                    data-vv-as="motivo"
                    v-validate="tipos.diaria ? 'required' : ''">
          </textarea>

          <p class="text-danger" v-show="errors.has('motivoDiaria')">{{ errors.first('motivoDiaria') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group" :class="{'has-error': errors.has('instituicaoVisitada')}">
          <label class="control-label" for="instituicao-visitada-diaria">Instituição Visitada</label>

          <input id="instituicao-visitada-diaria"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.instituicaoVisitada"
                 :disabled="!tipos.diaria"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('instituicaoVisitada')">{{ errors.first('instituicaoVisitada') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="fundacoesLiberadas.includes(configuracao.abreviaturaFundacao)">
      <div class="col-xs-12">
        <div class="form-group" :class="{'has-error': errors.has('localVisitado')}">
          <label class="control-label" for="local-visitado-diaria">Local Visitado</label>

          <input id="local-visitado-diaria"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.localVisitado"
                 :disabled="!tipos.diaria"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('localVisitado')">{{ errors.first('localVisitado') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="fundacoesLiberadas.includes(configuracao.abreviaturaFundacao)">
      <div class="col-xs-12">
        <div class="form-group" :class="{'has-error': errors.has('cidadeVisitada')}">
          <label class="control-label" for="cidade-visitada-diaria">Cidade Visitada</label>

          <input id="cidade-visitada-diaria"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.cidadeVisitada"
                 :disabled="!tipos.diaria"
                 maxlength="50">

          <p class="text-danger" v-show="errors.has('cidadeVisitada')">{{ errors.first('cidadeVisitada') }}</p>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso/componentes/compartilhado/FormDiarias.vue